import { render } from "./TheBanner.vue?vue&type=template&id=109e458e&scoped=true&lang=pug&bindings={\"itemsArray\":\"setup\",\"itemsArraySecond\":\"setup\",\"lang\":\"setup\",\"text\":\"setup\",\"textDown\":\"setup\",\"textQuality\":\"setup\"}"
import script from "./TheBanner.vue?vue&type=script&lang=js"
export * from "./TheBanner.vue?vue&type=script&lang=js"

import "./TheBanner.vue?vue&type=style&index=0&id=109e458e&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-109e458e"

export default script